/**
 * AI Jobs API - Yapay zeka analiz servisleri
 */
import { API_BASE_URL, tokenManager } from './api';

const BASE_URL = `${API_BASE_URL.replace('/api', '')}/api/ai`;

const getAuthHeaders = () => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${tokenManager.getAccessToken()}`
});

const apiRequest = async (url, options = {}) => {
    const response = await fetch(url, {
        ...options,
        headers: {
            ...getAuthHeaders(),
            ...options.headers
        }
    });

    if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.message || `API Error: ${response.status}`);
    }

    return response.json();
};

export const aiJobsAPI = {
    // Tek kayıt analizi
    analyzeSingle: (salesCallId) => {
        return apiRequest(`${BASE_URL}/analyze/sales-call/${salesCallId}/`, {
            method: 'POST'
        });
    },

    // Toplu analiz
    analyzeBulk: (data) => {
        return apiRequest(`${BASE_URL}/analyze/sales-calls/bulk/`, {
            method: 'POST',
            body: JSON.stringify(data)
        });
    },

    // Dashboard verileri
    getInsights: (startDate, endDate) => {
        return apiRequest(`${BASE_URL}/insights/sales-calls/?start_date=${startDate}&end_date=${endDate}`);
    },

    // AI özet oluştur
    generateSummary: (startDate, endDate) => {
        return apiRequest(`${BASE_URL}/insights/generate/`, {
            method: 'POST',
            body: JSON.stringify({
                start_date: startDate,
                end_date: endDate
            })
        });
    },

    // Analiz kayıtlarını listele
    getAnalyses: (startDate, endDate) => {
        let url = `${BASE_URL}/analyses/`;
        if (startDate && endDate) {
            url += `?start_date=${startDate}&end_date=${endDate}`;
        }
        return apiRequest(url);
    },

    // Özet kayıtlarını listele
    getSummaries: () => {
        return apiRequest(`${BASE_URL}/summaries/`);
    },

    // Çeviri
    translate: (text, targetLang = 'English') => {
        return apiRequest(`${BASE_URL}/translate/`, {
            method: 'POST',
            body: JSON.stringify({ text, target_lang: targetLang })
        });
    }
};

